import * as React from "react";
import { cn } from "@/lib/utils";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helpText?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, helpText, id: idProp, className, ...props }, ref) => {
    const generatedId = React.useId();
    const id = idProp ?? generatedId;

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={id}
            className="block text-sm font-medium text-ev-text-primary mb-1"
          >
            {label}
          </label>
        )}
        <input
          id={id}
          ref={ref}
          className={cn(
            "border rounded-ev px-3 py-2 text-ev-text-primary bg-ev-surface w-full",
            "focus:outline-none focus:ring-2 focus:border-ev-blue",
            "transition-colors duration-ev",
            error
              ? "border-ev-danger-text focus:ring-[oklch(0.40_0.12_20/0.25)]"
              : "border-ev-border focus:ring-ev-focus",
            className,
          )}
          {...props}
        />
        {error && (
          <p className="text-ev-danger-text text-sm mt-1" role="alert">
            {error}
          </p>
        )}
        {!error && helpText && (
          <p className="text-ev-text-muted text-sm mt-1">{helpText}</p>
        )}
      </div>
    );
  },
);
Input.displayName = "Input";

export { Input };
